export const chip = {
  zh: {
    noStock: "本季沒有股票申報紀錄",
    others: "其他",
    realEstate: "房地產",
    technology: "科技",
    industrials: "工業",
    consumerCyclical: "循環性消費",
    basicMaterials: "原物料",
    healthCare: "醫療保健",
    energy: "能源",
    financials: "金融服務",
    telecommunications: "電信",
    consumerNoncyclical: "非循環性消費",
    utilities: "公用事業",
    closePrice: "收盤價",
    costPrice: "交易量加權推估成本",
    cashSurplus: "資產凈增 (流入 - 流出)",
  },
  en: {
    noStock: "No stock declaration records this quarter",
    others: "Others",
    realEstate: "Real Estate",
    technology: "Technology",
    industrials: "Industrials",
    consumerCyclical: "Consumer Cyclical",
    basicMaterials: "Basic Materials",
    healthCare: "Health Care",
    energy: "Energy",
    financials: "Financials",
    telecommunications: "Telecommunications",
    consumerNoncyclical: "Consumer Noncyclical",
    utilities: "Utilities",
    closePrice: "Close Price",
    costPrice: "Cost Price",
    cashSurplus: "Cash Surplus",
  },
};
